import { createFileRoute } from "@tanstack/react-router";
import type { ClientUserHydrated } from "api-types/users/usersResponses";
import { getPostLoginRedirect } from "lib/auth";
import Footer from "lib/components/footers/LandingPageFooter";
import AccountSwitcher from "lib/components/home/AccountSwitcher";
import Navbar from "lib/components/home/Navbar";
import { useUserContext } from "lib/state/UserContextProvider";
import getPageTitle from "lib/utils/getPageTitle";
import { useEffect, useState } from "react";
import { Helmet as Head } from "react-helmet-async";
import Loading from "ui/components/Loading";
import useAppContext from "ui/hooks/useAppContext";
import styles from "../Home.module.scss";

function DashboardPage() {
  const [mounted, setMounted] = useState(false);
  const { setUserNotification } = useAppContext();
  const { user, userLoading } = useUserContext();

  const redirectUser = async (user: ClientUserHydrated | null, redirectTo?: string): Promise<void> => {
    const [url, notification] = await getPostLoginRedirect(user, redirectTo);

    if (notification) {
      setUserNotification(notification);
      return;
    }

    window.location.href = url;
  };

  useEffect(() => {
    setMounted(true);

    const shouldRedirect = !userLoading && user && user.builderAccounts && user.builderAccounts.length < 2;
    const noUser = !userLoading && !user;

    if (shouldRedirect || noUser) {
      void redirectUser(user, noUser ? window.location.pathname : undefined);
    }
  }, [user, userLoading]);

  if (!mounted) {
    return <div style={{ visibility: "hidden" }} />;
  }

  return (
    <div className={styles.wrapper}>
      <Head>
        <title>{getPageTitle("Accounts")}</title>
        <meta name="robots" content="noindex" />
      </Head>
      <Navbar />
      <div className="grid-container full-height">
        {userLoading || !user ? <Loading /> : <AccountSwitcher user={user} />}
      </div>
      <Footer />
    </div>
  );
}

export const Route = createFileRoute("/account/dashboard")({
  component: DashboardPage,
});
